import HttpClient from "./httpClient";

export interface ApplicationManaged {
  id: number;
  name: string;
  globally_enabled: boolean;
  customer_count: number;
  customers: string;
}

export interface CustomerManaged {
  id: number;
  name: string;
  psa_customer_id: string | null;
}

export interface PlatformIntegrated {
  type: string;
  name: string;
  endpoint: string;
  is_configured: boolean;
  action_count: number;
}

export interface ApplicationsResponse {
  total_count: number;
  applications: ApplicationManaged[];
}

export interface CustomersResponse {
  total_count: number;
  customers: CustomerManaged[];
}

export interface PlatformsResponse {
  total_count: number;
  platforms: PlatformIntegrated[];
}

export interface ManagingSummaryResponse {
  applications: ApplicationsResponse;
  customers: CustomersResponse;
  platforms: PlatformsResponse;
}

export interface DailyTicketsResponse {
  daily_tickets: Array<{
    ticket_date: string;
    ticket_count: number;
  }>;
}

export interface NeoMessagesResponse {
  message_count: number;
}

export interface DeviceActionsResponse {
  succeeded_actions: number;
  failed_actions: number;
  total_actions: number;
}

export interface ApiResponse<T> {
  status: 'success' | 'error';
  data: T;
  timestamp: string;
  error?: string;
}

class DashboardApi extends HttpClient {
  public getCustomersManaged = async (): Promise<CustomersResponse> => {
    const response: ApiResponse<CustomersResponse> = await this.get(`/api/dashboard/customers-managed`);
    return response.data;
  };

  public getApplicationsManaged = async (): Promise<ApplicationsResponse> => {
    const response: ApiResponse<ApplicationsResponse> = await this.get(`/api/dashboard/applications-managed`);
    return response.data;
  };

  public getPlatformsIntegrated = async (): Promise<PlatformsResponse> => {
    const response: ApiResponse<PlatformsResponse> = await this.get(`/api/dashboard/platforms-integrated`);
    return response.data;
  };

  public getDailyTickets = async (): Promise<DailyTicketsResponse> => {
    const response: ApiResponse<DailyTicketsResponse> = await this.get(`/api/dashboard/daily-tickets`);
    return response.data;
  };

  public getNeoMessages = async (): Promise<NeoMessagesResponse> => {
    const response: ApiResponse<NeoMessagesResponse> = await this.get(`/api/dashboard/neo-messages-last-7-days`);
    return response.data;
  };

  public getDeviceActions = async (): Promise<DeviceActionsResponse> => {
    const response: ApiResponse<DeviceActionsResponse> = await this.get(`/api/dashboard/device-actions-last-7-days`);
    return response.data;
  };

  public getManagingSummary = async (): Promise<ManagingSummaryResponse> => {
    const [applications, customers, platforms] = await Promise.all([
      this.getApplicationsManaged(),
      this.getCustomersManaged(),
      this.getPlatformsIntegrated()
    ]);
    return {
      applications,
      customers,
      platforms
    };
  };
}

export default new DashboardApi();
